import { styled, Stack, withUtility, breakpoints } from '@hub-la/design-system';

let _ = t => t,
  _t;
const Wrapper = styled(Stack)(_t || (_t = _`
  background-color: ${0};
  align-items: center;

  ${0} {
    position: fixed;
    left: 0;
    z-index: 999;
    bottom: 0;
  }
`), withUtility(({
  palette
}) => palette('surface')), breakpoints.down('md'));

export { Wrapper };
